export default __webpack_public_path__ + "static/advanced_v2-b7860ce09c38320b5ef81c492a3f1b3b.webp";